import apiClient from '@/services/apiClient'
import {
    DASHBOARD_SALES,
    DASHBOARD_SALES_CHART_DETAIL,
    DASHBOARD_SALES_CHART_NEW,
} from '@/data/url'

export const getSalesSummary = (payload = {}) =>
    apiClient.post(DASHBOARD_SALES, {
        ...payload,
    })

export const getSalesChart = (payload = {}) =>
    apiClient.post(DASHBOARD_SALES_CHART_NEW, {
        ...payload,
    })

export const getSalesDetail = (payload = {}) =>
    apiClient.post(DASHBOARD_SALES_CHART_DETAIL, {
        ...payload,
    })
